import PropTypes from "prop-types";

export default function Percentage({ children, decimalPlaces = 2 }) {
  return `${children.toFixed(children % 1 ? decimalPlaces : 0)}%`;
}

Percentage.propTypes = {
  children: PropTypes.number.isRequired,
  decimalPlaces: PropTypes.number,
};
